import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Box, Button, Divider, Flex, Tab, Tabs } from "@edreamsodigeo/prisma-design-system";
import BookingAuthentication from "../../../components/BookingAuthentication";
const MyTripsLoginTabs = ({
  activeTab,
  setActiveTab,
  UserAuthentication
}) => {
  const {
    t
  } = useTranslation();
  const tabs = [{
    title: t("mytripslogin.login.page.tab.login")
  }, {
    title: t("mytripslogin.login.page.tab.booking")
  }];
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Tabs, {
    value: activeTab
  }, tabs.map((tab, index) => /*#__PURE__*/React.createElement(Tab, {
    title: tab.title,
    key: index,
    onClick: () => setActiveTab(index)
  }))), /*#__PURE__*/React.createElement(Box, {
    mt: "big"
  }, activeTab ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(BookingAuthentication, null), /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    py: "big",
    alignItems: "center",
    gap: "base"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: "1"
  }, /*#__PURE__*/React.createElement(Divider, {
    orientation: "horizontal",
    sx: {
      flexGrow: "1"
    }
  })), /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "neutral.80"
  }, t("mytripslogin.login.page.social.divider")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: "1"
  }, /*#__PURE__*/React.createElement(Divider, {
    orientation: "horizontal",
    sx: {
      flexGrow: "1"
    }
  }))), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    fullWidth: true,
    onClick: () => {
      setActiveTab(0);
    }
  }, t("mytripslogin.login.page.tab.login"))) : UserAuthentication));
};
export default MyTripsLoginTabs;